export const START_CREATE_SCORE = "START_CREATE_SCORE";
export const START_PATCH_SCORE = "START_PATCH_SCORE";
export const START_CREATE_SCOREB = "START_CREATE_SCOREB";
export const CREATE_SCORE_SUCCESS = "CREATE_SCORE_SUCCESS";
export const PATCH_SCORE_SUCCESS = "PATCH_SCORE_SUCCESS";
export const CREATE_SCORE_SUCCESSB = "CREATE_SCORE_SUCCESSB";
export const CREATE_SCORE_FAIL = "CREATE_SCORE_FAIL";
export const PATCH_SCORE_FAIL = "PATCH_SCORE_FAIL";
export const CREATE_SCORE_FAILB = "CREATE_SCORE_FAILB";
